<template>
  <div class="custom-multiselect-container">
    <multi-select
      :value="value"
      label="name"
      track-by="id"
      :options="users"
      :loading="loading"
      :searchable="true"
      :multiple="false"
      placeholder="Search"
      :select-label="''"
      :deselect-label="''"
      :selected-label="''"
      @search-change="searchUsers"
      @input="onSelect"
      id="user-search-no-autofill"
      autocomplete="off"
      data-lpignore="true"
    >
      <template slot="caret">
        <div class="multiselect__select_custom"></div>
      </template>
    </multi-select>
  </div>
</template>
<script>
import MultiSelect from 'vue-multiselect'
import _debounce from 'lodash/debounce'
import { getUserList } from '@/services/user'

export default {
  name: "UserSearchSelect",
  components: { MultiSelect },
  props: {
    value: {
      type: Object,
      default: () => ({ id: null, name: null })
    }
  },
  data() {
    return {
      users: [],
      loading: false,
    }
  },
  methods: {
    searchUsers: _debounce(function(query) {
      if (!query || query.length < 2) return;

      this.loading = true;
      getUserList({ name: query })
        .then(response => {
          const data = response.data.items ? response.data.items : response.data;

          this.users = data.map(u => ({
            id: u.id,
            name: `${u.first_name} ${u.last_name}`
          }));
        })
        .catch(() => {
          this.users = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }, 600),

    onSelect(selectedOption) {
      if (!selectedOption) {
        this.$emit("input", { id: null, name: null });
      } else {
        this.$emit("input", selectedOption);
      }
    }
  },
  created() {
    if (this.value && this.value.id !== null) {
      this.users.push(this.value);
    }
  }
}
</script>

<style scoped>
::v-deep .multiselect__input {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
}

::v-deep input::-webkit-contacts-auto-fill-button,
::v-deep input::-webkit-credentials-auto-fill-button {
  visibility: hidden;
  display: none !important;
  pointer-events: none;
}

::v-deep .multiselect__tags {
  min-height: 38px !important;
  padding: 8px 35px 0 12px !important; /* Povećan desni padding na 35px */
  border: 1px solid #ced4da !important;
  border-radius: 5px !important;
}
::v-deep .multiselect__option--highlight::after,
::v-deep .multiselect__option::after {
  display: none !important;
  content: "" !important;
}


::v-deep .multiselect__single {
  padding-left: 0 !important;
  padding-top: 0 !important;
  font-size: 14px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}
</style>
